<script setup lang="ts">
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

import { useLogger } from 'vue-logger-plugin'
import { setStoreLogger } from '@/logger.ts'

import { ref, onMounted} from 'vue'

import {
  GetOrderTypeId,
  GetRootUrl,
  GetBeeNumberSite,
} from '@/stores/SettingsStore.ts'

import type { IAoeConsultant } from '@/types/ConsultantTypes'
import { GetConsultantFromLocalStorageOrApi } from '@/services/ConsultantService'
import { formatConsultantLocation } from '@/utils/locationHelper'

const logger = useLogger()


setStoreLogger(logger)

const orderTypeId = ref<string>('')
const rootUrl = ref<string>('')

const payeeSite = ref <IAoeConsultant | null>()

onMounted(async () => {
  logger.debug('onMounted')
  orderTypeId.value = await GetOrderTypeId()
  rootUrl.value = await GetRootUrl()
  Init();
})

 async function Init(){
  const beeNumberSite = await GetBeeNumberSite();
  if (beeNumberSite !== null) {
    GetConsultantFromLocalStorageOrApi(beeNumberSite).then((consultant) => {
      payeeSite.value = consultant
    })
  } else {
    logger.error('beeNumberSite is null');
  }
}
</script>

<template>
  <div class="aoe-consultant-detail container">
    <div v-if="payeeSite != null" class="row p-4 divConsultantDetails">
          <p class="OrderingWithLabel">{{ t('cart.OrderingWith') }}</p>
          <div class="row">
            <div class="col-4">
              <img
                  :src="payeeSite?.photoUrl"
                  :alt="t('cart.ConsultantPhotoAlt')"
                  class="payeePhoto">
            </div>
            <div class="col-8">
              <div class="divpayeeName">
                <div class="row">
                  <div class="col-12 payeeName">
                        {{ payeeSite?.firstName }} {{ payeeSite?.lastName }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 payeeLocation">
                        {{ formatConsultantLocation(payeeSite) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
  </div>
  <div id="overlay" class="overLayImages">
    </div>
</template>

<style lang="scss">

.overLayImages {
        position: fixed; /* Sit on top of the page content */
        display: none; /* Hidden by default */
        width: 100%; /* Full width (cover the whole page) */
        height: 100%; /* Full height (cover the whole page) */
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(black, 0.5); /* Black background with opacity */
        z-index: $z-kendo-popup-max; /* Specify a stack order in case you're using a different order for other elements */
        cursor: pointer; /* Add a pointer on hover */
    }

.aoe-consultant-detail {
  color:black;

  .OrderingWithLabel
  {
    @include typography-body-large;
  }

  .payeeLocation
  {
    @include typography-body;
  }

  .quantity {
    width: 50px;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    appearance: none;
    margin: 0;
  }
  input[type='number'] {
    appearance: textfield;
  }
  .k-numerictextbox .k-input-inner {
    text-align: right;
    @include font-weight-bold;
    color: none;
  }
  .k-numerictextbox .k-input-inner[disabled] {
    color: black;
  }
  .k-button-text {
    @include font-weight-bold;
  }
  .crosssell .k-numerictextbox .k-input-inner {
    text-align: center;
  }

  .crosssell .productName {
    text-align: center;
  }

  .k-input-flat {
    border-bottom-color: black !important;
  }


  .payeeName {
    @include typography-h4;
    @include font-weight-semibold;
    font-style: normal;
    line-height: 16px;
  }

  .connectToPartyInfo {
    @include typography-small;
    @include font-weight-regular;
    font-style: normal;
    line-height: 150%;
  }

  .divConsultantDetails {
    border-radius: $radius-md;
    border: 2px solid #ead9cf;
    background: #fbf7f5;
    padding: $spacing-12;
  }

  .k-scrollview {
    height: 375px;
    border: none;
  }

  .k-scrollview-next,
  .k-scrollview-prev {
    color: black;
  }

  .number .k-textbox {
    width: 40%;
  }

  .number .k-textbox .k-input-inner {
    text-align: center;
  }

  .k-input{
    vertical-align: -webkit-baseline-middle !important;
  }

  @media (min-width: 1025px) {
      .k-scrollview-wrap > .k-scrollview-view {
          display: flow-root !important;
      }
  }
}
</style>
